import React, { useEffect, useState } from "react";
import { Outlet } from "react-router-dom";
import Header from "../Header";
import Footer from "../Footer";
import useAuthTokenRefresher from "../../hooks/useAuthTokenRefresher";
import useSessionTimeout from "../../hooks/useSessionTimeout";
import { Loader, X } from "lucide-react";
import JoyRideSteps from "../Popup/JoyRideSteps";
import { removeSecureItems } from "../../helpers";

export default function Layout(props) {
  const {
    selectedPracticeChange = null,
    setSelectedPracticeChange = () => {},
    fetchChangePracticeData = false,
    setFetchChangePracticeData = () => {},
    smsLimit = {},
    setSmsLimit = () => {},
    letterLimit = {},
    setLetterLimit = () => {},
    setChangePracticeSpeciality = () => {},
    showPrevisitLoader = false,
    setShowPrevisitLoader = () => {},
    showPrevisitLoaderData = {},
    setPrevisitButtonLoader = () => {},
    setWaitingRoomProviders = () => {},
    showAICharting = false,
    ipaProfile = {},
    setIpaProfile = () => {},
    loadProfile = false,
    setLoadProfile = () => {}
  } = props
  useAuthTokenRefresher();
  useSessionTimeout();
  const [enableLoader, setEnableLoader] = useState(false);
  const [enableJoyride, setEnablejoyride] = useState(false);
  const [tourType, setTourType] = useState("automatic");

  // useEffect(() => {
  //   const timer = setTimeout(() => {
  //     setEnablejoyride(true);
  //   }, 5000);

  //   return () => clearTimeout(timer);
  // }, []);
  const stopPrevisitDownload = async () => {
    await removeSecureItems(["previsitDownloadData", "previsitDownloadFilter", "previsitDownloadLastId"]);
    setShowPrevisitLoader(false);
    setPrevisitButtonLoader(false);
  }

  return (
    <div className={`docpro_main ${ipaProfile?.ex_ipa?.id || !loadProfile ? "no-padding-left" : ""}`}>
      {enableJoyride && (
        <JoyRideSteps 
          selectedPracticeChange={selectedPracticeChange} 
          fetchChangePracticeData={fetchChangePracticeData}
          tourType={tourType}
          setTourType={setTourType}
        />
      )}
      <Header 
        setSelectedPracticeChange={setSelectedPracticeChange}
        setFetchChangePracticeData={setFetchChangePracticeData}
        smsLimit={smsLimit}
        setSmsLimit={setSmsLimit}
        setEnableLoader={setEnableLoader}
        letterLimit={letterLimit}
        setLetterLimit={setLetterLimit}
        selectedPracticeChange={selectedPracticeChange}
        fetchChangePracticeData={fetchChangePracticeData}
        setEnablejoyride={setEnablejoyride}
        setTourType={setTourType}
        setChangePracticeSpeciality={setChangePracticeSpeciality}
        setWaitingRoomProviders={setWaitingRoomProviders}
        setIpaProfile={setIpaProfile}
        loadProfile={loadProfile}
        setLoadProfile={setLoadProfile}
      />
      {!enableLoader ?
        <>
          <Outlet />
          {showPrevisitLoader && (
            <div className={`docpro_waiting_room_box ${showAICharting ? 'waiting_set_download_position' : ''}`}>
              <div className="percent">
                <svg className="progress">
                  <circle cx="20" cy="20" r="20"></circle>
                  <circle cx="20" cy="20" r="20" style={{ strokeDashoffset: `calc(140 - (140 * ${showPrevisitLoaderData?.percentage || 0}) / 100)` }}></circle>
                </svg>
                <div className="num">
                  <h2>{showPrevisitLoaderData?.percentage || 0}<span>%</span></h2>
                </div>
              </div>
              <div className="close" onClick={() => stopPrevisitDownload()}>
                <X width={15} height={15}/>
              </div>
              <h2 className="text">Complete {showPrevisitLoaderData?.completed_count || 0} of {(showPrevisitLoaderData?.pending_count || 0) + (showPrevisitLoaderData?.completed_count || 0)}</h2>
            </div>
          )}
        </>
      :
        <div className="flex items-center loading" style={{ width: '100%', height: '80vh', justifyContent: 'center' }}>
          <span className="docpro_loading" style={{ position: 'inherit' }}>
            <Loader width={46} height={46} style={{ color: 'var(--accent)' }} />
          </span>
        </div>
      }
      <Footer />
    </div>
  );
}
